import axios, { AxiosError, AxiosResponse } from "axios";
import BaseService from "./baseService";
import { AXIOS_TIMEOUT_ERROR_MESSAGE } from "constants/api";
import { authStorage } from "constants/storage";

const httpBearer = axios.create({
  timeout: 600000,
  timeoutErrorMessage: AXIOS_TIMEOUT_ERROR_MESSAGE,
  headers: {
    "Content-Type": "application/json",
  },
});

httpBearer.interceptors.request.use((config) => {
  if (!config.headers) config.headers = {};

  if (authStorage.token)
    config.headers.Authorization = `Bearer ${authStorage.token}`;

  return config;
});

httpBearer.interceptors.response.use(
  async (response: AxiosResponse) => {
    return response.data;
  },
  async (error: AxiosError) => {
    const data = error?.response?.data;

    return {
      apiPath: error.config.url,
      errorCode: error.response?.status || error.message,
      errors: data?.errors || data?.data?.errors,
    };
  }
);

export default class HttpBearerService extends BaseService {
  http = httpBearer;
}
